import { SessionTimeoutModal } from "./SessionTimeoutModal/SessionTimeoutModal";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { routes } from "../../routes/routes.constatns";

export function AutoLogout() {
  const { instance, accounts, inProgress } = useMsal();
  const [isSessionTimeoutModalVisible, setSessionTimeoutModalVisible] =
    useState(false);

  let idleTimeout = 1000 * 60 * 10; //10 minutes
  let idleLogout = 1000 * 60 * 15; //15 Minutes
  let idleEvent;
  let idleLogoutEvent;

  const events = useMemo(() => ["mousemove", "click", "keypress", "scroll", "load"], []);

  /**
   * @method sessionTimeout
   * This function is called with each event listener to set a timeout or clear a timeout.
   */
  const sessionTimeout = useCallback(() => {
    if (!!idleEvent) clearTimeout(idleEvent);
    if (!!idleLogoutEvent) clearTimeout(idleLogoutEvent);

    idleEvent = setTimeout(
      () => setSessionTimeoutModalVisible(true),
      idleTimeout
    ); //show session warning modal.
    idleLogoutEvent = setTimeout(() => logOut(), idleLogout); //Call logged out on session expire.
  }, [idleTimeout, idleLogout]);

  /**
   * @method logOut
   * This function will destroy current user session.
   */
  const logOut = async () => {
    sessionStorage.clear();
    localStorage.clear();


    if (inProgress === InteractionStatus.None && accounts.length > 0) {
      instance
        .logoutRedirect({
          account: instance.getActiveAccount(),
          postLogoutRedirectUri: `${process.env.REACT_APP_URL_REG_ALL}${routes.home}`,
        })
        .catch((e) => {
          sessionStorage.clear();
          document.cookie = "msal.interaction.status=;";
          instance.logoutRedirect({
            postLogoutRedirectUri: `${process.env.REACT_APP_URL_REG_ALL}${routes.home}`,
          });
        });
    }
  };
 
useEffect(() => {
    for (let e in events) {
      window.addEventListener(events[e], sessionTimeout);
}

 return () => {
      for (let e in events) {
        window.removeEventListener(events[e], sessionTimeout);
 }
};
 }, [events, sessionTimeout]);


  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, null, window.location.href);
    };
  }, []);

  return (
    <SessionTimeoutModal
      isModalVisible={isSessionTimeoutModalVisible}
      onCancel={() => {
        logOut();
        setSessionTimeoutModalVisible(false);
      }}
      onConfirm={() => {
        setSessionTimeoutModalVisible(false);
        clearTimeout(idleEvent);
        clearTimeout(idleLogoutEvent);

        for (let e in events) {
          window.removeEventListener(events[e], sessionTimeout);
          window.addEventListener(events[e], sessionTimeout);
        }
      }}
    />
  );
}
